<template>
  <div class="contents">
    <top></top>
    <div class="title">订阅服务</div>
    <div class="sub-title">专属 VIP 一选即享</div>
    <div class="buy-box">
      <div class="buy-item">
        <div class="buy-item-t">
          <div class="icon">
            <img src="../../assets/image/free.png" alt="" />
          </div>
          <div class="item-title">免费</div>
        </div>
        <div class="buy-item-b">
          <div class="buy-item-lits">
            <img src="../../assets/image/gou2.png" alt="" />
            <span class="m-title">创建项目</span>
          </div>
          <div class="buy-item-lits">
            <img src="../../assets/image/gou2.png" alt="" />
            <span class="m-title">收件箱</span>
          </div>
          <div class="buy-item-lits">
            <img src="../../assets/image/gou3.png" alt="" />
            <span class="m-title">智能AI</span>
          </div>
          <div class="buy-item-lits">
            <img src="../../assets/image/gou3.png" alt="" />
            <span class="m-title">专属客服</span>
          </div>
        </div>
      </div>
      <div class="buy-item" v-for="(item, index) in customerPackageList" :key="index">
        <div class="buy-item-t" style="background: #f4f8fe">
          <div class="icon">
            <img src="../../assets/image/Subtract.png" alt="" />
          </div>
          <div class="item-title">
            <span class="mtl">{{ item.packageName }}</span>
            <span>${{ item.periodPrice }}<span class="mm">/月</span></span>
          </div>
        </div>
        <div class="buy-item-b">
          <div class="buy-item-lits" v-for="(item2, index) in item.packageDesc.split(',')" :key="index">
            <img src="../../assets/image/gou.png" alt="" />
            <span class="m-title">{{ item2 }}</span>
          </div>
        </div>
        <el-button
          v-if="detail.isMember && item.id == detail.packageId"
          class="btn"
          @click="handleOpen(item, '2')"
          type="primary"
          >续费</el-button
        >
        <el-button v-else-if="!detail.isMember" class="btn" @click="handleOpen(item, '1')" type="primary"
          >开通</el-button
        >
      </div>
    </div>

    <el-dialog title="订阅套餐" :visible.sync="dialogVisible" width="30%">
      <div class="dialog-form">
        <div class="form-item">
          <div class="label">订阅周期</div>
          <div class="content">
            <el-input-number
              v-model="form.period"
              :min="newPackage.period"
              :max="100000"
              :step="1"
              step-strictly
            ></el-input-number>
          </div>
        </div>
        <div class="form-item">
          <div class="label">到期时间</div>
          <div class="content">{{ resultDate }}</div>
        </div>
        <div class="form-item">
          <div class="label">
            <span>订阅席位</span>
            <span class="tip">套餐包含一个席位，超出另收费每位 ${{ newPackage.seatPrice || 0 }}/月</span>
          </div>
          <div class="content">
            <el-input-number
              v-model="form.seats"
              :min="newPackage.initialSeats"
              :max="100000"
              :step="1"
              step-strictly
            ></el-input-number>
          </div>
        </div>
        <div class="form-item">
          <div class="label">支付方式</div>
          <div class="content">
            <img style="width: 20px; height: 20px; margin-right: 10px" src="../../assets/image/shuzi.png" alt="" />
            <span>数字货币USDT</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">选择网络</div>
          <div class="content">
            <el-select v-model="coinId" @change="handleChange" placeholder="请选择">
              <el-option v-for="item in coinList" :key="item.chain_id" :label="item.title" :value="item.chain_id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item">
          <div class="label">
            <span>翻译包</span>
            <span class="tip">${{ newPackage.translatePrice || 0 }}/百万字符</span>
          </div>
          <div class="content">
            <el-select v-model="form.translateCount" clearable placeholder="请选择">
              <el-option v-for="item in translateOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="form-item">
          <div class="label">余额</div>
          <div class="content">
            <span class="num" v-if="accmount <= detail.balance"
              >$ {{ detail.balance }} - {{ accmount }}</span
            >
            <span v-else class="error"
              >余额不足需充值 $ {{ accmount - detail.balance }}</span
            >
          </div>
        </div> -->
        <div class="form-item">
          <div class="label">合计</div>
          <div class="content num">$ {{ accmount }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" class="order-btn" @click="activate">支付订单</el-button>
      </div>
    </el-dialog>

    <el-dialog title="续费套餐" :visible.sync="dialogVisible2" width="30%">
      <div class="dialog-form">
        <div class="form-item">
          <div class="label">订阅周期</div>
          <div class="content">
            <el-input-number v-model="form2.period" :min="1" :max="100000" :step="1" step-strictly></el-input-number>
          </div>
        </div>
        <div class="form-item">
          <div class="label">到期时间</div>
          <div class="content">{{ resultDate2 }}</div>
        </div>
        <div class="form-item">
          <div class="label">支付方式</div>
          <div class="content">
            <img style="width: 20px; height: 20px; margin-right: 10px" src="../../assets/image/shuzi.png" alt="" />
            <span>数字货币USDT</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">选择网络</div>
          <div class="content">
            <el-select @change="handleChange" v-model="coinId" placeholder="请选择">
              <el-option v-for="item in coinList" :key="item.chain_id" :label="item.title" :value="item.chain_id">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="form-item">
          <div class="label">余额</div>
          <div class="content">
            <span class="num" v-if="accmount2 <= detail.balance"
              >$ {{ detail.balance }} - {{ accmount2 }}</span
            >
            <span v-else class="error"
              >余额不足需充值 $ {{ accmount2 - detail.balance }}</span
            >
          </div>
        </div> -->
        <div class="form-item">
          <div class="label">合计</div>
          <div class="content num">$ {{ accmount2 }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" class="order-btn" @click="renew">续费订单</el-button>
      </div>
    </el-dialog>

    <el-dialog title="待支付" @opened="handleOpenDia" @closed="handleClose" :visible.sync="dialogVisible3" width="30%">
      <div class="dialog-form">
        <div class="form-item" style="justify-content: center">
          <div class="form-accmount">
            <div class="accmount-tl">支付金额</div>
            <div class="accmount-num">$ {{ rowData.amount }}</div>
            <div class="accmount-text">
              剩余支付时间 <span class="accmount-text-date">{{ timeText }}</span>
            </div>
          </div>
        </div>
        <div class="form-item" style="justify-content: center">
          <div class="content" style="width: 50%">
            <img style="width: 100%" :src="rowData.qrCode" alt="" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">收款地址</div>
          <div class="content">{{ rowData.address || "--" }}</div>
        </div>
        <div class="form-item">
          <div class="label">支付方式</div>
          <div class="content">
            <span>{{ rowData.paymentMethod || "--" }}</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">订单编号</div>
          <div class="content">
            <span>{{ rowData.cid || "--" }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" class="order-btn" @click="dialogVisible3 = false">已支付</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import top from "./components/top.vue";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      translateOptions:[],
      coinId: "",
      address: "",
      qrCodeUrl: "",
      form: {
        seats: "",
        period: "",
        translateCount:""
      },
      form2: {
        period: "",
      },
      rowData: {},
      newPackage: {},
      customerPackageList: [],
      coinList: [],
      now: Date.now(),
      timer: null,
    };
  },
  mounted() {
    this.$store.dispatch("loadPackageInfo");
    this.getCoinList();
    this.getPackageList();
    this.getData('customer_translate');
  },
  watch: {
    timeText(newValue, oldValue) {
      if (newValue == "00:00:00") {
        this.$message({
          type: "warning",
          message: "订单已过期",
        });
        setTimeout(() => {
          this.dialogVisible3 = false;
        }, 1000);
      }
    },
  },
  computed: {
    timeText() {
      const end = new Date(this.rowData.expirationTime).getTime();
      let diff = end - this.now;

      if (diff <= 0) {
        return "00:00:00";
      }

      const totalSeconds = Math.floor(diff / 1000);

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return (
        String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
      );
    },
    resultDate() {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 30);
      const calculatedDate = new Date(currentDate.getTime() + 30 * 24 * 60 * 60 * 1000 * this.form.period);
      return calculatedDate.toLocaleDateString() + " 00:00:00";
    },
    resultDate2() {
      if (!this.detail.expireTime) return "--";
      const date = new Date(this.detail.expireTime + this.form2.period * 30 * 24 * 60 * 60 * 1000);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}/${month}/${day} 00:00:00`;
    },
    accmount() {
      const period = Number(this.form.period) || 0;
      const translateCount = Number(this.form.translateCount) || 0;
      const discount = Number(this.newPackage.discount) || 1;
      // 周期价格
      const base = (Number(this.newPackage.periodPrice) || 0) * period;
      // 席位数（不能为负）
      const seatCount = Math.max((Number(this.form.seats) || 0) - (Number(this.newPackage.initialSeats) || 0), 0);
      // 席位价格
      const seat = seatCount * period * (Number(this.newPackage.seatPrice) || 0);
      // 翻译包
      const translate = (Number(this.newPackage.translatePrice) || 0) * translateCount;
      const total = (base + seat + translate) * discount;
      // 不四舍五入，保留两位
      const factor = 100;
      const truncated = total >= 0 ? Math.floor(total * factor) : Math.ceil(total * factor);
      return (truncated / factor).toFixed(2);
    },
    accmount2() {
      const period = Number(this.form2.period) || 0;
      const discount = Number(this.newPackage.discount) || 1;
      const periodPrice = Number(this.newPackage.periodPrice) || 0;
      const seatPrice = Number(this.newPackage.seatPrice) || 0;
      // 周期价格
      const base = periodPrice * period;
      // 购买席位数（不能为负）
      const buySeats = Number(this.detail.buySeats) || 0;
      const initialSeats = Number(this.newPackage.initialSeats) || 0;
      const seatCount = Math.max(buySeats - initialSeats, 0);
      // 席位价格
      const seat = seatCount * period * seatPrice;
      const total = (base + seat) * discount;
      // 不四舍五入，保留两位（正负数安全）
      const factor = 100;
      const truncated = total >= 0 ? Math.floor(total * factor) : Math.ceil(total * factor);
      return (truncated / factor).toFixed(2);
    },
    detail() {
      return this.$store.state.userStore.packageInfo;
    },
  },
  components: {
    top,
  },
  methods: {
    getData(key){
      this.$http({
        url: `/customer/getTranslateDict/${key}`,
        method: "get",
      }).then((res) => {
        this.translateOptions = res.data;
      });
    },
    getPackageList() {
      this.$http({
        url: "/customer/package/list",
        method: "get",
      }).then((res) => {
        this.customerPackageList = res.rows;
      });
    },
    getCoinList() {
      this.$http({
        url: "/customer/getCoinList",
        method: "get",
      }).then((res) => {
        this.coinList = res.address_coins.filter((item) => item.title === "USDT-ERC20" || item.title === "USDT-TRC20");
      });
    },
    handleOpen(item, val) {
      this.newPackage = item;
      this.coinId = this.coinList[0].chain_id;
      if (val == 1) {
        this.form.seats = "";
        this.form.period = "";
        this.form.translateCount = "";
        this.getAddress(this.coinId);
        this.dialogVisible = true;
      } else if (val == 2) {
        this.form2.period = "";
        this.getAddress(this.coinId);
        this.dialogVisible2 = true;
      }
    },
    handleOpenDia(){
      this.now = Date.now();
      this.timer = setInterval(() => {
        this.now = Date.now();
      }, 1000);
    },
    handleClose() {
      this.rowData = {};
      this.timer && clearInterval(this.timer);
    },
    activate() {
      this.$confirm("你确认要订阅该套餐, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: "/customer/package/buy",
          method: "POST",
          data: {
            packageId: this.newPackage.id,
            period: this.form.period,
            seats: this.form.seats,
            paymentMethod: this.coinId,
            address: this.address,
            qrCode: this.qrCodeUrl,
            translateCount: this.form.translateCount,
            type: "1",
          },
        }).then((res) => {
          this.$store.dispatch("loadPackageInfo");
          this.rowData = JSON.parse(res.packageJson);
          Object.assign(this.rowData, { amount: res.amount, expirationTime: res.expirationTime, cid: res.cid });
          this.dialogVisible = false;
          setTimeout(() => {
            this.dialogVisible3 = true;
          }, 500);
        });
      });
    },
    renew() {
      this.$confirm("你确认要续费该套餐, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: "/customer/package/renew",
          method: "POST",
          data: {
            packageId: this.newPackage.id,
            period: this.form2.period,
            paymentMethod: this.coinId,
            address: this.address,
            qrCode: this.qrCodeUrl,
            type: "2",
          },
        }).then((res) => {
          this.$store.dispatch("loadPackageInfo");
          this.rowData = JSON.parse(res.packageJson);
          Object.assign(this.rowData, { amount: res.amount, expirationTime: res.expirationTime, cid: res.cid });
          this.dialogVisible2 = false;
          setTimeout(() => {
            this.dialogVisible3 = true;
          }, 500);
        });
      });
    },
    handleChange(val) {
      this.getAddress(val);
    },
    getAddress(val) {
      this.$http({
        url: "/customer/getAddress",
        method: "POST",
        data: {
          chain_id: val,
        },
      }).then((res) => {
        this.address = res.address;
        this.qrCodeUrl = res.qrCodeUrl;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  padding: 20px 20px 0;
  text-align: left;
  font-weight: bold;
  color: #000;
  font-size: 15px;
}
.sub-title {
  padding: 0 20px;
  text-align: left;
  color: #666666;
  font-size: 13px;
  margin-top: 10px;
}
.buy-box {
  padding: 0px 20px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .buy-item {
    margin-top: 20px;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 300px;
    height: 500px;
    background: #fff;
    border: 1px solid #e6e6e6;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;
    margin-right: 40px;
    cursor: default;
  }
  .buy-item:hover {
    border: 1px solid #0068ff;
  }
}
.buy-item-t {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f4f4fe;
  padding: 20px;
  .icon {
    width: 92px;
    height: 92px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .item-title {
    display: flex;
    flex-direction: column;
    font-weight: bold;
    font-size: 30px;
    color: #333333;
    margin-left: 20px;
    .mtl {
      font-size: 18px;
    }
    .mm {
      font-size: 14px;
      color: #999999;
    }
  }
}
.buy-item-b {
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0;
}
.buy-item-lits {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  img {
    width: 20px;
    height: 20px;
  }
}
.buy-item-lits:last-child {
  margin-bottom: 0px;
}
.m-title {
  font-size: 14px;
  margin-left: 10px;
}
.btn {
  width: 90%;
  height: 40px;
  background: #0167ff;
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, -50%);
}
.btn:hover {
  opacity: 0.8;
}
.buy-option-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .buy-option-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    .buy-label {
      width: 50%;
      font-weight: bold;
    }
    .buy-input {
      width: 40%;
      color: #000;
      text-align: right;
    }
    .labeltitle {
      font-size: 11px;
      color: #999999;
    }
  }
}
.order-btn {
  width: 100%;
}

.dialog-form {
  display: flex;
  flex-direction: column;
  .form-item {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .label {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .tip {
        font-size: 12px;
        color: #999999;
      }
    }
    .content {
      display: flex;
      align-items: center;
      .con-img {
        width: 100%;
      }
    }
    .form-accmount {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: default;
      .accmount-num {
        color: #333;
        font-weight: bold;
        font-size: 30px;
        padding: 10px 0;
      }
      .accmount-text-date {
        font-weight: bold;
        font-size: 18px;
        color: #d35846;
      }
    }
  }
}
.num {
  font-weight: bold;
  color: #333333;
  font-size: 18px;
}
.error {
  color: red;
  margin-left: 10px;
  font-size: 13px;
}
</style>
